import { createFileRoute } from '@tanstack/react-router'
import ProfileSettings from '@/pages/settings/profile'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/profile'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <ProfileSettings />
}
